<template>
  <el-menu
    :collapse="isCollapse"
    router
    :default-active="value"
    class="main-nav-menu"
    @open="handleOpen"
    @close="handleClose"
    background-color="#252f40"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <template v-for="item in menuTree">
      <el-submenu v-if="item.children" :index="item.index" :key="item.index">
        <template #title>
          <component :is="getIconComponent(item.icon)" :icon="item.icon" />
          <span>{{ item.title }}</span>
        </template>
        <template v-for="group in item.children">
          <el-menu-item-group
            v-if="group.groupTitle"
            :title="group.groupTitle"
            :key="group.groupTitle"
          >
            <el-menu-item
              v-for="sub in group.items"
              :index="sub.index"
              :key="sub.index"
            >
              <component
                v-if="sub.icon"
                :is="getIconComponent(sub.icon)"
                :icon="sub.icon"
              />
              {{ sub.title }}
            </el-menu-item>
          </el-menu-item-group>
          <el-submenu
            v-else-if="group.children"
            :index="group.index"
            :key="group.index"
          >
            <template #title>
              <component
                v-if="group.icon"
                :is="getIconComponent(group.icon)"
                :icon="group.icon"
              />
              {{ group.title }}
            </template>
            <el-menu-item
              v-for="sub in group.children"
              :index="sub.index"
              :key="sub.index"
            >
              <component
                v-if="sub.icon"
                :is="getIconComponent(sub.icon)"
                :icon="sub.icon"
              />
              {{ sub.title }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :index="group.index" :key="String(group.index)">
            <component
              v-if="group.icon"
              :is="getIconComponent(group.icon)"
              :icon="group.icon"
            />
            {{ group.title }}
          </el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item
        v-else
        :index="item.index"
        :disabled="item.disabled"
        :key="String(item.index)"
      >
        <component :is="getIconComponent(item.icon)" :icon="item.icon" />
        <span>{{ item.title }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import BrainSvg from "!!raw-loader!@/assets/brain.svg"; // Assuming you have a brain icon SVG
import SvgIcon from "@/components/SvgIcon.vue";

// 图标渲染组件
const ElIcon = {
  functional: true,
  props: ["icon"],
  render(h, ctx) {
    return h("i", { class: ctx.props.icon });
  },
};

const ImgIcon = {
  functional: true,
  props: ["icon"],
  render(h, ctx) {
    return h("img", {
      attrs: {
        src: ctx.props.icon,
        width: 24,
        height: 24,
        style: "vertical-align:middle;",
      },
    });
  },
};
export default {
  components: { ElIcon, SvgIcon, ImgIcon },
  name: "MainNavMenu",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuTree: [
        {
          index: "/dashboard",
          icon: "el-icon-location",
          title: "Dashboard",
        },
        {
          index: "/devices",
          icon: "el-icon-menu",
          title: "Devices",
        },
        {
          index: "/map",
          icon: "el-icon-map-location",
          title: "Map",
        },
        {
          index: "/connect",
          icon: "el-icon-connection",
          title: "Connect",
        },
        {
          index: "/ai",
          icon: BrainSvg,
          title: "AI & Intelligence",
          children: [
            {
              index: "/ai-agents",
              icon: "el-icon-chat-dot-square",
              title: "AI Agents",
            },
            {
              index: "/ai-audit-logs",
              icon: "el-icon-s-order",
              title: "Events & AI Audit",
            },
          ],
        },
        {
          index: "/shadow",
          icon: "el-icon-cloudy",
          title: "Shadow",
        },
        {
          index: "/app",
          icon: "el-icon-mobile-phone",
          title: "App",
        },
        {
          index: "/workflows",
          icon: "el-icon-s-operation",
          title: "Workflows",
          children: [
            {
              index: "/flow",
              title: "Flow",
            },
            {
              index: "/ruleflow",
              title: "RuleFlow",
            },
          ],
        },
        {
          index: "/settings",
          icon: "el-icon-setting",
          title: "System & Management",
          children: [
            {
              index: "/settings/users",
              icon: "el-icon-user",
              title: "Users",
            },
            {
              index: "/settings/whats-app-alerts-v2",
              icon: "el-icon-s-custom",
              title: "WhatsApp Alerts",
            },
            {
              index: "/settings/digital-displays",
              icon: "el-icon-monitor",
              title: "Digital Displays",
            },
            {
              index: "/settings",
              icon: "el-icon-setting",
              title: "Platform Settings",
            },
          ],
        },
      ],
    };
  },
  methods: {
    getIconComponent(icon) {
      if (!icon) return ElIcon;
      // svg字符串或对象
      if (
        (typeof icon === "string" && icon.startsWith("<svg")) ||
        (typeof icon === "object" &&
          icon.default &&
          icon.default.startsWith("<svg"))
      ) {
        return {
          functional: true,
          props: ["icon"],
          render(h, ctx) {
            return h(SvgIcon, {
              props: { src: ctx.props.icon },
            });
          },
        };
      }
      // img路径（如 .svg/.png/.jpg）
      if (typeof icon === "string" && /\.(svg|png|jpg|jpeg|gif)$/.test(icon)) {
        return ImgIcon;
      }
      return ElIcon;
    },
    handleOpen() {},
    handleClose() {},
  },
  computed: {
    value() {
      return this.$route.path;
    },
  },
};
</script>
<style lang="scss">
.main-nav-menu {
  border-right: none;
  [class^="fa"],
  .svg-icon {
    display: inline-flex;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    vertical-align: middle;
  }
}

.el-menu-item [class^="svg-icon"] {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
</style>
